import {
  showErrorSnackbar,
  showSuccessSnackbar
} from 'components/shared/Snackbar';
import { useMutation, useQueryClient } from 'react-query';
import { addOrRemoveFlexMatchQualification } from 'RestAPIs/flex-match';
import { FlexMatchQualificationMutationPayload } from 'RestAPIs/flex-match/types';

const useAddOrRemoveQualification = ({ isWebSocketUpdate = false }) => {
  const queryClient = useQueryClient();

  return useMutation(
    (payload: FlexMatchQualificationMutationPayload) =>
      addOrRemoveFlexMatchQualification(payload),
    {
      onSuccess: () => {
        !isWebSocketUpdate &&
          queryClient.invalidateQueries('requestQualifications');
        showSuccessSnackbar();
      },
      onError: () => {
        showErrorSnackbar();
      }
    }
  );
};

export default useAddOrRemoveQualification;
